import { render } from "./finance-hero.vue?vue&type=template&id=5c3df796"
import script from "./finance-hero.vue?vue&type=script&lang=js"
export * from "./finance-hero.vue?vue&type=script&lang=js"

import "./finance-hero.vue?vue&type=style&index=0&id=5c3df796&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__